import { KeyRound } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiError, api } from '../lib/api.ts';
import { useAuth } from '../lib/auth.tsx';

export function ChangePassword() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [current, setCurrent] = useState('');
    const [next, setNext] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);

    const forced = user?.mustChangePassword ?? false;

    const submit = async (e: React.FormEvent): Promise<void> => {
        e.preventDefault();
        if (next !== confirm) {
            setError('Les deux saisies ne correspondent pas.');
            return;
        }
        setBusy(true);
        setError(null);
        try {
            await api('/auth/change-password', {
                method: 'POST',
                body: { currentPassword: current, newPassword: next },
            });
            // Le serveur révoque toutes les sessions : il faut se reconnecter.
            await logout();
            void navigate('/connexion');
        } catch (err) {
            setError(err instanceof ApiError ? err.message : 'Modification impossible');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="mx-auto max-w-sm py-6">
            <h1 className="mb-1 text-xl font-bold">Changer de mot de passe</h1>
            {forced && (
                <div role="alert" className="alert alert-warning my-4 text-sm">
                    <span>
                        Ce compte utilise encore son mot de passe initial. Choisissez-en un autre
                        pour continuer.
                    </span>
                </div>
            )}

            <form onSubmit={(e) => void submit(e)} className="mt-4 space-y-4">
                <label className="form-control w-full">
                    <span className="label-text mb-1 block text-sm">Mot de passe actuel</span>
                    <input
                        type="password" className="input input-bordered w-full"
                        value={current} onChange={(e) => setCurrent(e.target.value)}
                        autoComplete="current-password" required autoFocus
                    />
                </label>
                <label className="form-control w-full">
                    <span className="label-text mb-1 block text-sm">Nouveau mot de passe</span>
                    <input
                        type="password" className="input input-bordered w-full"
                        value={next} onChange={(e) => setNext(e.target.value)}
                        autoComplete="new-password" minLength={12} required
                    />
                    <span className="mt-1 block text-xs opacity-60">
                        12 caractères minimum. Une phrase est plus sûre et plus facile à retenir
                        qu'un mot court avec des symboles.
                    </span>
                </label>
                <label className="form-control w-full">
                    <span className="label-text mb-1 block text-sm">Confirmation</span>
                    <input
                        type="password" className="input input-bordered w-full"
                        value={confirm} onChange={(e) => setConfirm(e.target.value)}
                        autoComplete="new-password" required
                    />
                </label>

                {error && (
                    <div role="alert" className="alert alert-error text-sm"><span>{error}</span></div>
                )}

                <button type="submit" className="btn btn-primary btn-block tap-target" disabled={busy}>
                    {busy ? <span className="loading loading-spinner" /> : <KeyRound size={20} />}
                    Valider
                </button>
            </form>
        </div>
    );
}
